export const FORECAST_STATUS_KEY = 'forecast';
export const CLIENT_ATTRIBUTION_CONTACTS_STATUS_KEY = 'clientAttributionContacts';
export const FORECAST_ADMIN_JOB_STATUS_KEY = 'forecastAdminJobStatus';

export const getSections = (routes, selectedClients, allowProcessAi, icons, isFinanceUser) => {
  const {
    AdminPanelSettingsRounded,
    WorkRounded,
    EventNoteIcon,
    PeopleRounded,
    HubIcon,
    DescriptionOutlinedIcon,
    LanRounded,
    UpdateIcon,
    AutoGraphIcon,
    FlagIcon,
    StorageIcon,
    PersonAddAlt1Icon,
    PersonIcon,
    ManageHistoryRounded,
    HandymanIcon,
    SettingsIcon,
    ExitToAppIcon,
    LinkIcon,
    ReceiptLongIcon,
    UploadIcon,
    SyncIcon,
    MondayIcon,
    AssignmentTurnedInIcon,
    HelpOutlineIcon,
  } = icons;

  const selectedClientId = selectedClients && selectedClients.length === 1 ? selectedClients[0].id : null;

  const sections = [
    {
      subheader: 'Client',
      items: [
        {
          title: 'Profile',
          icon: WorkRounded,
          disabledStatusKey: ['requiresClientSelection'],
          route: routes.app.profile.route,
        },
        ...(allowProcessAi
          ? [
              {
                title: 'Weekly Call',
                icon: EventNoteIcon,
                disabledStatusKey: 'requiresClientSelection',
                route: routes.app.weeklyCall.route,
              },
            ]
          : []),
        {
          title: 'Team Permissions',
          icon: PeopleRounded,
          disabledStatusKeys: ['requiresClientSelection', 'clientPending'],
          route: routes.app.team.route,
        },
        {
          title: 'Client Attribution',
          icon: HubIcon,
          statusKey: CLIENT_ATTRIBUTION_CONTACTS_STATUS_KEY,
          disabledStatusKey: 'requiresClientSelection',
          route: {
            accessible: true,
            path: selectedClientId ? `/client-attribution-detail` : '#',
            href: selectedClientId ? `/client-attribution-detail?clientId=${selectedClientId}` : '#',
          },
        },
        {
          title: 'Manage Services',
          icon: DescriptionOutlinedIcon,
          disabledStatusKey: 'requiresClientSelection',
          route: routes.app.manageServices.route,
        },
        {
          title: 'Data Integrations',
          icon: LanRounded,
          disabledStatusKeys: ['requiresClientSelection', 'dataIntegrationsClientPending'],
          route: {
            accessible: true,
            splitTarget: 'content',
            externalUrl: selectedClientId ? 'https://harvestgroup.atlassian.net/servicedesk/customer/portal/12' : '#',
            path: selectedClientId ? 'https://harvestgroup.atlassian.net/servicedesk/customer/portal/12' : '#',
          },
        },
        {
          title: 'Actuals',
          icon: ReceiptLongIcon,
          disabledStatusKey: 'requiresClientSelection',
          route: routes.app.estimateActuals.route,
        },
        {
          title: 'Forecast Roundtable',
          icon: UpdateIcon,
          statusKey: FORECAST_STATUS_KEY,
          disabledStatusKeys: ['requiresClientSelection', 'clientPending'],
          route: routes.app.forecastRoundtableTool.route,
        },
        ...(allowProcessAi || isFinanceUser
          ? [
              {
                title: 'Forecasting',
                icon: AutoGraphIcon,
                statusKey: FORECAST_STATUS_KEY,
                disabledStatusKey: 'requiresClientSelection',
                route: routes.app.forecastingV2.route,
              },
            ]
          : []),
        {
          title: 'Goals Tracker',
          icon: FlagIcon,
          disabledStatusKeys: ['requiresClientSelection', 'clientPending'],
          route: routes.app.clientGoalsTracker.route,
        },
        {
          title: 'Ember Dataset Manager',
          icon: StorageIcon,
          disabledStatusKeys: ['requiresClientSelection', 'clientPending'],
          route: routes.app.emberDatasetManager.route,
        },
      ],
    },
    {
      subheader: 'Global',
      items: [
        {
          title: 'Client & Services Directory',
          icon: HubIcon,
          route: {
            accessible: true,
            path: '/client-services-directory',
          },
        },
        {
          title: 'Client Onboarding',
          icon: PersonAddAlt1Icon,
          route: {
            accessible: true,
            path: '/client-onboarding',
          },
        },
        {
          title: 'Permission Management',
          icon: PersonIcon,
          route: routes.app.permissions.route,
        },
        ...(isFinanceUser
          ? [
              {
                title: 'Forecast Roundtable',
                icon: UpdateIcon,
                route: routes.app.forecastRoundtableTool.route,
                suppressActive: selectedClients && selectedClients.length === 1,
              },
            ]
          : []),
      ],
    },
    {
      subheader: 'Administration',
      items: [
        {
          title: 'Forecast Roundtable Manager',
          icon: ManageHistoryRounded,
          route: routes.app.forecastRoundtableManager.route,
        },
        ...(allowProcessAi || isFinanceUser
          ? [
              {
                title: 'Forecast Administration',
                icon: AdminPanelSettingsRounded,
                statusKey: FORECAST_ADMIN_JOB_STATUS_KEY,
                route: routes.app.forecastAdministration.route,
              },
            ]
          : []),
        {
          title: 'Client Manager',
          icon: HandymanIcon,
          route: routes.app.clientManager.route,
        },
        {
          title: 'Guest User Requests',
          icon: AssignmentTurnedInIcon,
          route: routes.app.guestUserRequests.route,
        },
        {
          title: 'Client Attribution Manager',
          icon: SettingsIcon,
          route: routes.app.clientAttributionManager.route,
        },
        {
          title: 'Client Offboarding Dashboard',
          icon: ExitToAppIcon,
          route: routes.app.clientOffboardingDashboard.route,
        },
        {
          title: 'NetSuite Client Mapping',
          icon: LinkIcon,
          route: routes.app.netsuiteClientMapping.route,
        },
        {
          title: 'PBCS File Uploader',
          icon: UploadIcon,
          route: routes.app.pbcsFileUploader.route,
        },
        {
          title: 'Harvester Status',
          icon: SyncIcon,
          route: routes.app.harvesterStatus.route,
        },
        {
          title: 'Monday Manager',
          icon: MondayIcon,
          route: routes.app.mondayBatchSync.route,
        },
      ],
    },
    {
      subheader: 'Help',
      items: [
        {
          title: 'Help Center',
          icon: HelpOutlineIcon,
          route: routes.app.help.route,
        },
      ],
    },
  ];

  return sections
    .map((section) => {
      const items = section.items
        .map((item) => {
          if (!item.route) {
            return null;
          }

          const childItems = item.items ? item.items.filter((child) => child.route?.accessible) : undefined;

          if (childItems && childItems.length === 0) {
            return null;
          }

          if (!item.route.accessible) {
            return null;
          }

          return {
            ...item,
            ...(childItems ? { items: childItems } : {}),
          };
        })
        .filter(Boolean);

      return { ...section, items };
    })
    .filter((section) => section.items.length);
};
